import { create } from 'zustand'

import type { Detail } from '@/api/orders/orders-types'

interface MultiStepStore {
  multiStep: boolean
  resetMultiStep: () => void
  toggleMultiStep: () => void
  selectedDetails: Detail[]
  setSelectedDetails: (details: Detail[]) => void
  toggleSelectedDetail: (detail: Detail) => void
  isSelected: (detail: Detail) => boolean
}

export const useMultistep = create<MultiStepStore>()((set, get) => ({
  multiStep: false,
  selectedDetails: [],
  resetMultiStep: () => {
    set({ multiStep: false })
    set({ selectedDetails: [] })
  },
  toggleMultiStep: () => set((state) => ({ multiStep: !state.multiStep })),
  setSelectedDetails: (details: Detail[]) => set({ selectedDetails: details }),
  toggleSelectedDetail: (detail: Detail) => {
    set((state) => {
      const isCurrentlySelected = state.selectedDetails.some((d) => d.autoid === detail.autoid)
      if (isCurrentlySelected) {
        return {
          selectedDetails: state.selectedDetails.filter((d) => d.autoid !== detail.autoid)
        }
      } else {
        return {
          selectedDetails: [...state.selectedDetails, detail]
        }
      }
    })
  },
  isSelected: (detail: Detail) => {
    return get().multiStep ? get().selectedDetails.some((d) => d.autoid === detail.autoid) : false
  }
}))
